import * as React from 'react';

import { telemetryConsumerWrapper } from '../../../../app/contexts/TelemetryConsumerWrapper';
import { FavoriteToggleClickedTelemetryContext } from '../../../../app/contexts/TelemetryContexts';
import { PageHeaderButtonType } from '../../../../app/layout/PageHeader';
import { Messages } from '../../../../codegen/Localize';
import { FavoriteToggleClickedEventHandler, FavoriteToggleType } from '../../../telemetryEvents/types/ContentTelemetryTypes';

export class FavoriteToggle extends React.PureComponent<FavoriteToggle.Props, FavoriteToggle.State> {

  static displayName = 'FavoriteToggle';

  static element = React.createFactory(FavoriteToggle);

  constructor(props: FavoriteToggle.Props){
    super (props);
    this.state = { isFavorite: this.props.isFavorite };
  }

  public componentWillReceiveProps(nextProps: FavoriteToggle.Props){
    this.setState({ isFavorite: nextProps.isFavorite });
  }

  public render() {
    // default button type is regular
    const classes = this.props.buttonType === 'light' ? ['tb-favorite-button-light'] : ['tb-favorite-button'];
    if (this.state.isFavorite) {
      classes.push('tb-selected');
    }

    return telemetryConsumerWrapper(FavoriteToggleClickedTelemetryContext.Consumer, (sendFavoriteToggleClickTelemetry: FavoriteToggleClickedEventHandler) =>
      <span className={ classes.join(' ') }
                 tabIndex={ this.props.canHaveKeyboardFocus ? 0 : null }
                 onClick={(event: React.SyntheticEvent<HTMLSpanElement>) => {
                  sendFavoriteToggleClickTelemetry(this.state.isFavorite ? FavoriteToggleType.Unfavorite : FavoriteToggleType.Favorite);
                  this.boundHandleClick(event);
                 }}
                 onKeyDown={ this.props.canHaveKeyboardFocus ? this.boundHandleKeypress: null }
                 title={ this.getTitleIfApplicable() } />
    );
  }

// this needs to cause a re-render. Best way to do this is to actually give it state, because that's what is really happening
  private boundHandleClick = (event: React.SyntheticEvent<HTMLSpanElement>) => {
    this.state.isFavorite ? this.props.onRemoveFavorite() : this.props.onAddFavorite();
    this.setState({ isFavorite: !this.state.isFavorite }); // trigger re-render
    event.preventDefault();
    event.stopPropagation();
  }

  private boundHandleKeypress = (event: React.KeyboardEvent<HTMLSpanElement>) => {
    if (event.key === 'Enter') {
      this.boundHandleClick(event);
    }
  }

  private getTitleIfApplicable() {
    if (!!this.props.hideHelpTooltip) {
      return undefined;
    }

    return  Messages.favoritesTitle();
  }
}

export namespace FavoriteToggle {

  export interface Props {
    isFavorite: boolean;
    onAddFavorite: () => void;
    onRemoveFavorite: () => void;
    canHaveKeyboardFocus: boolean;
    hideHelpTooltip?: boolean;
    buttonType?: PageHeaderButtonType;
  }

  export interface State {
    isFavorite: boolean;
  }

}
